module.exports = __webpack_public_path__ + "img/HappyPhoto26.e018a8ed.jpeg";